<a href="javascript:;" (click)="handleOnClickProductDetail(product)">
  <div class="imgWrap">
    <div class="mark">
      <ng-container *ngIf="isMatchDate(product.recomnSDate , product.recomnEDate)">
        <span class="mark-best">BEST</span>
      </ng-container>

      <ng-container *ngIf="isMatchDate(product.newSDate , product.newEDate)">
        <span class="mark-new">NEW</span>
      </ng-container>

      <ng-container *ngIf="isMatchDate(product.eventSDate , product.eventEDate)">
        <span class="mark-sale">SALE</span>
      </ng-container>
    </div>
    <ng-container *ngIf="product.fileName === null || product.fileName === ''">
      <img src="./assets/img/noImage.jpg" alt="">
    </ng-container>
    <ng-container *ngIf="product.fileName !== null && product.fileName !== ''">
      <img data-src="{{urlWownet + product.filePath + product.fileName}}" alt="product">
    </ng-container>

    <span class="mark-right" (click)="onClickWishList($event)">
      <ng-container *ngIf="wishYN == 'N' || wishYN == ''">
        <img src="../../../assets/lasted/img/icon/btn_like.svg" alt="like">
      </ng-container>
      <ng-container *ngIf="wishYN == 'Y'">
        <img src="../../../assets/lasted/img/icon/btn_liked.svg" alt="like">
      </ng-container>
    </span>

  </div>
  <p class="text-start text-name">{{product.pdtName}}</p>
  <ng-container *ngIf="product.cateCD.substr(2,2) == '90'">
    <p class="text-start text-name">(구매는 더조각 채널톡 문의)</p>
  </ng-container>
</a>
<ng-container *ngIf="product.cateCD.substr(2,2) != '90'">
  <div class="price-wrap d-flex">
    <ng-container *ngIf="isLogined">
      <ng-container *ngIf="rankCd != '00'">
        <p class="price-left w-auto">{{ 'currency' | translate: { param: product.amt | setComma:'price':'' } }}</p>
        <p class="price-next w-auto mx-2"><del>{{ 'currency' | translate: { param: product.retailAmt |
            setComma:'price':''
            }
            }}</del></p>
      </ng-container>
      <ng-container *ngIf="rankCd == '00'">
        <p class="price-left w-auto">{{ 'currency' | translate: { param: product.retailAmt | setComma:'price':'' } }}</p>
      </ng-container>

    </ng-container>
    <ng-container *ngIf="!isLogined">
      <p class="price-left w-auto">{{ 'currency' | translate: { param: product.retailAmt | setComma:'price':'' } }}</p>
    </ng-container>
  </div>
  <div class="pv-wrap d-flex d-none">
    <ng-container *ngIf="isLogined && rankCd != '00'">
      <p class="pv-left w-auto" *ngIf="isPv1">{{ smWowWord.oPv1 }}{{ product.pv1 | setComma: '':'' }}</p>
      <p class="pv-left w-auto text-secondary mx-2" *ngIf="isPv2">{{ smWowWord.oPv2 }}{{ product.pv2 | setComma: '':''
        }}
      </p>
      <p class="pv-left w-auto text-secondary mx-2" *ngIf="isPv3">{{ smWowWord.oPv3 }}{{ product.pv3 | setComma: '':''
        }}
      </p>
    </ng-container>

    <ng-container *ngIf="!isLogined">
      <ng-container *ngIf="isAmt">
        <p class="pv-left w-auto" *ngIf="isPv1">{{ smWowWord.oPv1 }}{{ product.pv1 | setComma: '':'' }}</p>
        <p class="pv-left w-auto text-secondary mx-2" *ngIf="isPv2">{{ smWowWord.oPv2 }}{{ product.pv2 | setComma: '':''
          }}</p>
        <p class="pv-left w-auto text-secondary mx-2" *ngIf="isPv3">{{ smWowWord.oPv3 }}{{ product.pv3 | setComma: '':''
          }}</p>
      </ng-container>
    </ng-container>
  </div>
  <div class="col-auto quantity-input row w-100 mt-3">
    <div class="cal-btn minus col-2" (click)="handleOnChangeQuanity(minus);"
      [ngClass]="{'disable-btn': (product.saleMaxQty == 0 && product.saleMinQty == 0)}">
      <img src="./assets/img/icons/quantity-minus.svg">
    </div>
    <div class="value col w-100"><span id="qty" class="w-100 text-center">{{ quantities | setComma:'':'' }}</span></div>
    <div class="cal-btn plus col-2" (click)="handleOnChangeQuanity(plus);"
      [ngClass]="{'disable-btn': (product.saleMaxQty == 0 && product.saleMinQty == 0)}">
      <img src="./assets/img/icons/quantity-plus.svg">
    </div>
  </div>
  <button type="button" class="btn mt-3 w-100 btn-add-card" (click)="onAddToCart()">장바구니</button>
</ng-container>
